import React from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface DIDErrorModalProps {
  onClose: (data: { success: boolean; submitWithoutLines?: boolean }) => void;
}

const DIDErrorModal: React.FC<DIDErrorModalProps> = ({ onClose }) => {
  const handleClose = () => {
    onClose({ success: false });
  };

  const handleSubmitWithoutLines = () => {
    onClose({ success: true, submitWithoutLines: true });
  };

  return (
    <>
      <ModalHeader toggle={handleClose}>DID Purchase Error</ModalHeader>
      <ModalBody>
        <p>We can't buy DIDs and configure lines now. Do you want to submit order without lines?</p>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={handleClose}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSubmitWithoutLines}>
          Submit Without Lines
        </Button>
      </ModalFooter>
    </>
  );
};

export default React.memo(DIDErrorModal);
